import { render, staticRenderFns } from "./new-resource.vue?vue&type=template&id=51fb9db7&"
import script from "./new-resource.vue?vue&type=script&lang=js&"
export * from "./new-resource.vue?vue&type=script&lang=js&"
import style0 from "./new-resource.vue?vue&type=style&index=0&id=51fb9db7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports